import { defineMessages } from "react-intl";

export default defineMessages({
  usageLimitsTitle: {
    id: "pzSF+b",
    defaultMessage: "Usage Limit",
    description: "voucher usage limit, header",
  },
  hasUsageLimit: {
    id: "Qj/3sH",
    defaultMessage: "Limit number of times this discount can be used in total",
    description: "limit voucher",
  },
  usageLimit: {
    id: "s51tHd",
    defaultMessage: "Limit of Uses",
    description: "limit voucher",
  },
  usesLeftCaption: {
    id: "o8S0Ac",
    defaultMessage: "Uses left",
    description: "usage limit uses left caption",
  },
  applyOncePerCustomer: {
    id: "vTgRTZ",
    defaultMessage: "Limit to one use per customer",
    description: "limit voucher",
  },
  onlyForStaff: {
    id: "+jHXT3",
    defaultMessage: "Limit to staff only",
    description: "limit voucher",
  },
});
